/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useDispatch } from "react-redux";
import {
  deleteDocumentData,
  getAllDocuments,
} from "../../../../Services/DocumentUpload/documentUploadApi";
import { toast } from "react-toastify";

const DeleteDocument = ({ id, communityIdForDoc, page, pageSize, search }) => {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const modalId = `deleteDocumentModal-${id}`; // Create unique modal ID for each document

  const confirmDelete = async () => {
    try {
      await dispatch(deleteDocumentData(id)).unwrap();
      toast.success("Document deleted successfully");
      dispatch(
        getAllDocuments({
          community_id: communityIdForDoc,
          page: page,
          page_size: pageSize,
          search: search,
          access: "all",
          user_id: userId,
        })
      )
        .unwrap()
        .catch((err) => {
          console.error("Error fetching documents after delete:", err);
          toast.error("Failed to refresh document list.");
        });
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Failed to delete document");
    }
  };

  return (
    <>
      <a title="Delete" style={{ cursor: "pointer" }}>
        <div
          className="dustbin-icon"
          data-bs-toggle="modal"
          data-bs-target={`#${modalId}`} // Use unique modal ID
        >
          <svg
            height="14"
            viewBox="0 0 13 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.7296 2.35905H9.65408V2.06273C9.65408 1.36769 9.08864 0.802246 8.3936 0.802246H4.6064C3.91136 0.802246 3.34592 1.36769 3.34592 2.06273V2.35905H1.2704C1.00895 2.35934 0.758291 2.46332 0.573404 2.64818C0.388517 2.83304 0.284496 3.08368 0.284157 3.34513V3.81265C0.284157 4.32161 0.671837 4.74161 1.1672 4.79345L2.18272 13.7048C2.27952 14.5558 2.99872 15.1976 3.85536 15.1976H9.14448C10.0011 15.1976 10.7203 14.5558 10.8171 13.7048L11.8326 4.79345C12.0749 4.76767 12.2991 4.65326 12.4621 4.47222C12.6251 4.29117 12.7154 4.05626 12.7157 3.81265V3.34513C12.7153 3.08368 12.6113 2.83304 12.4264 2.64818C12.2415 2.46332 11.991 2.35934 11.7296 2.35905ZM3.98608 2.06273C3.98625 1.89822 4.05167 1.74049 4.168 1.62417C4.28432 1.50784 4.44205 1.44242 4.60656 1.44225H8.39376C8.55827 1.44242 8.71599 1.50784 8.83231 1.62417C8.94864 1.74049 9.01407 1.89822 9.01424 2.06273V2.35905H3.98608V2.06273ZM10.1814 13.6323C10.1526 13.887 10.0309 14.1221 9.8397 14.2928C9.64848 14.4635 9.4011 14.5577 9.1448 14.5576H3.85568C3.59937 14.5577 3.35199 14.4635 3.16078 14.2928C2.96956 14.1221 2.8479 13.887 2.81904 13.6323L1.81248 4.79889H11.1882L10.1814 13.6323ZM12.076 3.81265C12.0759 3.90444 12.0393 3.99243 11.9744 4.05733C11.9095 4.12224 11.8215 4.15876 11.7298 4.15889H1.2704C1.17861 4.15876 1.09061 4.12224 1.02571 4.05733C0.960803 3.99243 0.924284 3.90444 0.924157 3.81265V3.34513C0.924157 3.15441 1.07952 2.99905 1.2704 2.99905H11.7294C11.9203 2.99905 12.0757 3.15441 12.0757 3.34513V3.81265H12.076Z"
              fill="#414141"
            />
            <path
              d="M6.5 12.8257C6.58487 12.8257 6.66626 12.792 6.72627 12.732C6.78628 12.672 6.82 12.5906 6.82 12.5057V6.85101C6.82 6.76614 6.78628 6.68474 6.72627 6.62473C6.66626 6.56472 6.58487 6.53101 6.5 6.53101C6.41513 6.53101 6.33373 6.56472 6.27372 6.62473C6.21371 6.68474 6.18 6.76614 6.18 6.85101V12.5057C6.18 12.5906 6.21371 12.672 6.27372 12.732C6.33373 12.792 6.41513 12.8257 6.5 12.8257ZM8.41296 12.8108C8.45478 12.815 8.49699 12.8108 8.5372 12.7986C8.5774 12.7863 8.6148 12.7663 8.64725 12.7396C8.67971 12.7129 8.70658 12.6801 8.72634 12.643C8.7461 12.6059 8.75835 12.5653 8.7624 12.5235L9.31056 6.89533C9.31881 6.81086 9.29317 6.72658 9.23928 6.66101C9.18539 6.59545 9.10766 6.55398 9.0232 6.54573C8.98132 6.54136 8.939 6.54535 8.89868 6.55747C8.85836 6.56959 8.82085 6.5896 8.78833 6.61633C8.75581 6.64306 8.72892 6.67599 8.70922 6.7132C8.68953 6.75041 8.67742 6.79116 8.6736 6.83309L8.12544 12.4612C8.11718 12.5457 8.14282 12.63 8.19671 12.6956C8.2506 12.7611 8.32849 12.8026 8.41296 12.8108ZM4.55568 12.8124C4.60035 12.8125 4.64454 12.8032 4.68539 12.7851C4.72625 12.767 4.76287 12.7406 4.79289 12.7075C4.82291 12.6744 4.84567 12.6354 4.85971 12.593C4.87375 12.5506 4.87875 12.5057 4.8744 12.4612L4.32624 6.83309C4.3224 6.79117 4.31027 6.75043 4.29057 6.71323C4.27087 6.67603 4.24398 6.64311 4.21146 6.61638C4.17894 6.58965 4.14144 6.56964 4.10113 6.55751C4.06082 6.54539 4.01851 6.54138 3.97664 6.54573C3.89217 6.55398 3.81444 6.59545 3.76055 6.66101C3.70666 6.72658 3.68102 6.81086 3.68928 6.89533L4.23744 12.5235C4.24514 12.6025 4.28197 12.6759 4.34076 12.7293C4.39954 12.7827 4.47625 12.8123 4.55568 12.8124Z"
              fill="#414141"
            />
          </svg>
        </div>
      </a>
      <div
        className="modal fade"
        id={modalId} // Use unique modal ID
        tabIndex="-1"
        aria-labelledby={`${modalId}Label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id={`${modalId}Label`}>
                Delete Document
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <label htmlFor="communitySelect" className="form-label">
                Are you sure you want to delete Document
              </label>
            </div>
            <div className="modal-footer community-footer">
              <button
                type="button"
                className="bttn-close"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="bttn-upload"
                data-bs-dismiss="modal"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteDocument;
